import { JSX } from 'react';

import { Badge, FlexAligner, Tooltip } from '@scaleaq/scaleui';

import { Z_INDEX } from '@/constants';
import { responsive } from '@/utils';

import {
  StyledHeaderItem,
  StyledHeaderTitle,
} from './cameraHeaderTitle/cameraHeaderTitle.styles.ts';
import { StyledPenName } from './cameraStreamWidget.styles.ts';

type CameraHeaderTitleProps = {
  currentSite: { name: string } | undefined;
  headerName: string | undefined;
  headerTooltip: JSX.Element | string | undefined;
};

export const CameraHeaderTitle = ({
  currentSite,
  headerName,
  headerTooltip,
}: CameraHeaderTitleProps) => {
  return (
    <StyledHeaderTitle gap={responsive.spacing.small} alignment='center-left' fullWidth={false}>
      <FlexAligner alignment='center-left'>
        {headerName && (
          <Tooltip
            usePortal
            zIndex={Z_INDEX.content.floatingTooltip}
            placement='bottom-end'
            tooltip={headerTooltip}
          >
            <StyledPenName type='body_large'>{headerName}</StyledPenName>
          </Tooltip>
        )}
        <StyledHeaderItem>
          <Badge size='medium' type='info' outline label={currentSite?.name ?? ''} />
        </StyledHeaderItem>
      </FlexAligner>
    </StyledHeaderTitle>
  );
};
